import { environment } from '@env/environment';

import { importProvidersFrom } from '@angular/core';

import { QuillModule } from 'ngx-quill';
import { NgEventOptionsModule } from 'ng-event-options';
import { provideScrollbarOptions } from 'ngx-scrollbar';
import { FONT_PICKER_CONFIG, FontPickerConfigInterface } from 'ngx-font-picker';

import { ZEF_BREAKPOINTS } from '@shared/breakpoints';
import { StorageModule } from '@shared/modules/storage.module';
import { ZefSentryModule } from '@shared/modules/sentry/zef-sentry.module';
import { MediaMonitorModule } from '@shared/modules/media-monitor.module';
import { DROPZONE_CONFIG, DropzoneConfigInterface } from 'ngx-dropzone-wrapper';

const DEFAULT_FONT_PICKER_CONFIG: FontPickerConfigInterface = {
  apiKey: environment.googleBrowserKey,
};

const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
  autoReset: 0,
  errorReset: 5000,
  maxFiles: 1,
  maxFilesize: 10,
  acceptedFiles: 'image/jpg, image/jpeg, image/png, image/gif',
  createImageThumbnails: false,
};

export const customProviders = [
  provideScrollbarOptions({
    orientation: 'vertical',
    appearance: 'compact',
    visibility: 'native',
    trackScrollDuration: 0,
  }),

  importProvidersFrom(
    StorageModule,
    NgEventOptionsModule,
    QuillModule.forRoot(),
    ZefSentryModule,
    MediaMonitorModule.forRoot(ZEF_BREAKPOINTS),
  ),

  { provide: FONT_PICKER_CONFIG, useValue: DEFAULT_FONT_PICKER_CONFIG },

  { provide: DROPZONE_CONFIG, useValue: DEFAULT_DROPZONE_CONFIG },
];
